import React, { Fragment, useEffect, useState } from 'react';
import './StatusContainer.scss';
import { ObjectContainerClientT, StatusClientT } from 'bovaljaren-models';
import { getObjectClassNameFromStatus } from '../../image/mapping/SvgMapping/SvgMapping';
import { isMobile } from '../../../utils/app.helper';

type Props= {
    showStatusContainer: boolean;
    objects?: ObjectContainerClientT[];
    statuses?: StatusClientT[];
    rounded?: boolean;
    sideBar?: boolean;
}

/**
 * Missing good implementation on how the image should be presented.
 * Needs to be implemented once we know how the drawer should look.
 */

const StatusContainer: React.FC<Props> = ({ showStatusContainer, objects, statuses, rounded = false, sideBar = true }) => {
    const [statusSummary, setStatusSummary] = useState<{ singular: string; plural: string; count: number; id: number }[]>();

    useEffect(() => {
        if (objects && statuses) {
            setStatusSummary(statuses?.map(({ singular, plural, id }) => ({ singular, id, plural, count: objects?.filter(o => o.statusId === id)?.length || 0 })));
        }
    }, [objects, statuses]);

    return (
        <div className={'bv-status-container-wrapper'}>
            {showStatusContainer && <div className={`bv-status-container${sideBar ? ' bv-status-container--sidebar' : ''}${isMobile() ? ' bv-status-container--mobile ' : ''}`}>
                <div className={`bv-status-container-inner${sideBar ? ' bv-status-container-inner--sidebar' : ''}${isMobile() ? ' bv-status-container-inner--mobile ' : ''}`}>
                    {statusSummary?.filter(s => s.count > 0).map(({ singular, plural, count, id }) =>
                        <div key={singular + plural} className={`bv-status-row${sideBar ? ' bv-status-row--sidebar' : ''}${isMobile() ? ' bv-status-row--mobile ' : ''}`}>
                            <div className={`bv-status-count ${`${getObjectClassNameFromStatus(statuses, id)}-tl` || 'bv-available-tl' } ${sideBar ? ' bv-status-count--sidebar' : ''}${isMobile() ? ' bv-status-count--mobile ' : ''}`}><p>{count}</p></div>
                            <div className={`bv-status-text${sideBar ? ' bv-status-text--sidebar' : ''}${isMobile() ? ' bv-status-text--mobile ' : ''}`}>{count > 1 ? plural : singular}</div>
                        </div>)}
                </div>
            </div>}
        </div>
    );
};


export default StatusContainer;